<template>
  <div class="v-table-tr" >
    <span v-if="pageInfo" class="h-tag h-tag-primary page-info" style="">{{ pageInfo }}</span>
    <div @click="newRow" class="v-table-tr-plus"><i class="fa fa-plus-circle"></i></div>
    <v-table-summary ref="summaryRef"
                     :summary="voucherDetail.summary"
                     :detail="voucherDetail"
                     :rowIndex="rowIndex"/>
    <v-table-subject ref="subjectRef"
                     :subjectList="subjectList"
                     :subjectMap="subjectMap"
                     :subject="voucherDetail.subject"
                     :auxiliary="voucherDetail.auxiliary"
                     :detail="voucherDetail"
                     :rowIndex="rowIndex"/>
    <v-table-debit ref="debitRef"
                   :subject="voucherDetail.subject"
                   :detail="voucherDetail"
                   :debit="voucherDetail.debitAmount"
                   :debitFor="voucherDetail.debitAmountFor"
                   :rowIndex="rowIndex"/>
    <v-table-credit ref="creditRef"
                    :detail="voucherDetail"
                    :subject="voucherDetail.subject"
                    :credit="voucherDetail.creditAmount"
                    :creditFor="voucherDetail.creditAmountFor"
                    :rowIndex="rowIndex"/>
    <div @click="rmRow" class="v-table-tr-minus"><i class="fa fa-minus-circle"></i></div>
  </div>
</template>

<script setup>
import VTableSummary from "@components/VoucherTable/VTableSummary.vue";
import VTableSubject from "@components/VoucherTable/VTableSubject.vue";
import VTableDebit from "@components/VoucherTable/VTableDebit.vue";
import VTableCredit from "@components/VoucherTable/VTableCredit.vue";
import {getCurrentInstance, onMounted, ref, computed } from "vue";
import {getVTable} from "@components/VoucherTable/VtUtil";

const props = defineProps(['voucherDetail', 'rowIndex', 'subjectList', 'subjectMap', 'totalRow', 'pageLine']);

const summaryRef = ref(null);
const subjectRef = ref(null);
const debitRef = ref(null);
const creditRef = ref(null);
let VTableTr = null;

const newRow = () => {
  VTableTr.exposed.newRow(props.rowIndex);
}

const rmRow = () => {
  VTableTr.exposed.rmRow(props.rowIndex);
}

// const rowClick = () => {
//   // console.log(props.voucherDetail.debitAmount);
// }

// 定义计算属性
const pageInfo = computed(() => {
  let pageInfo = '';
  let pageLine = props.pageLine;
  if(pageLine == undefined || pageLine == ""){
    pageLine = 8;
  }
  const page = Math.ceil((props.rowIndex+1)/pageLine);
  const pageindex = (props.rowIndex) % pageLine;

  const pages = Math.ceil(props.totalRow/pageLine);
  if(pages>1 && pageindex==0){
    pageInfo = page + "/" + pages;
  }else{
    pageInfo = '';
  }
  return pageInfo;
});

onMounted(() => {
  VTableTr = getVTable(getCurrentInstance());
  VTableTr.exposed.pushColInstance(props.rowIndex, {
    summary: summaryRef.value,
    subject: subjectRef.value,
    debitAmount: debitRef.value,
    creditAmount: creditRef.value
  });
})
</script>

<style scoped lang="less">
.v-table {
  &-tr {
    height: 70px;
    border-bottom: @border;
    display: flex;
    position: relative;

    &:last-child {
      border-bottom: none;
    }

    &-plus, &-minus {
      display: none;
      position: absolute;
      font-size: 18px;
      cursor: pointer;
      top: 18px;
    }

    &-plus {
      left: -18px;
      color: @green-color;
      padding:0 5px;
    }

    &-minus {
      right: -18px;
      color: @red-color;
      padding:0 5px;
    }

    &:hover {
      .v-table-tr-plus, .v-table-tr-minus {
        display: inline-block;
      }
    }
  }
}
.page-info{
  position:absolute;left:-20px;top:2px;height:18px;padding:2px;
  z-index:1;
}
</style>
